// LOAD CAROUSEL IMAGES ONLY AFTER STOPPED SCROLLING
// Vanilla JavaScript: Lazy-load alternate product images on scroll-stop within the specific carousel in view
(function() {
    // Delay (ms) to consider scroll "stopped"
    var scrollStopDelay = 200;
    var scrollTimer;
  
    // Helper: check if an element is in the viewport
    function isInViewport(el) {
      var win = window;
      var winTop = win.pageYOffset || win.scrollY;
      var winBottom = winTop + win.innerHeight;
      var rect = el.getBoundingClientRect();
      var elTop = rect.top + winTop;
      var elBottom = elTop + el.offsetHeight;
      return elBottom > winTop && elTop < winBottom;
    }
  
    // Helper: load images for the previous carousel in Grid__Cell
    function loadPreviousCarouselImages(currentCarousel) {
      var currentCell = currentCarousel.closest('.Grid__Cell');
      if (currentCell) {
        var prevCell = currentCell.previousElementSibling;
        // Find previous Grid__Cell without hidden-phone class
        while (prevCell && prevCell.classList.contains('hidden-phone')) {
          prevCell = prevCell.previousElementSibling;
        }
        if (prevCell && prevCell.classList.contains('Grid__Cell')) {
          var prevCarousel = prevCell.querySelector('.Swipe__Mobile__CollectionCarousel');
          if (prevCarousel) {
            var prevAlternateImages = prevCarousel.querySelectorAll('.js-ProductItem__Image--alternate');
            var prevImagesToLoad = Array.from(prevAlternateImages).map(function(container) {
              return container.querySelector('img');
            }).filter(function(img) {
              return img.getAttribute('data-src-2');
            });
  
            if (prevImagesToLoad.length > 0) {
              var prevLoadedCount = 0;
              prevImagesToLoad.forEach(function(img) {
                var onPrevImageLoad = function() {
                  prevLoadedCount++;
                  if (prevLoadedCount === prevImagesToLoad.length) {
                    console.log('previous images loaded');
                    prevCarousel.classList.add('is-image-loaded');
                  }
                };
  
                img.addEventListener('load', onPrevImageLoad);
                img.addEventListener('error', onPrevImageLoad);
                
                img.setAttribute('src', img.getAttribute('data-src-2'));
  
                if (img.complete) {
                  img.removeEventListener('load', onPrevImageLoad);
                  onPrevImageLoad();
                }
              });
            }
          }
        }
      }
    }
  
    // Helper: load images for the next carousel in Grid__Cell
    function loadNextCarouselImages(currentCarousel) {
      var currentCell = currentCarousel.closest('.Grid__Cell');
      if (currentCell) {
        var nextCell = currentCell.nextElementSibling;
        // Find next Grid__Cell without hidden-phone class
        while (nextCell && nextCell.classList.contains('hidden-phone')) {
          nextCell = nextCell.nextElementSibling;
        }
        if (nextCell && nextCell.classList.contains('Grid__Cell')) {
          var nextCarousel = nextCell.querySelector('.Swipe__Mobile__CollectionCarousel');
          if (nextCarousel) {
            var nextAlternateImages = nextCarousel.querySelectorAll('.js-ProductItem__Image--alternate');
            var nextImagesToLoad = Array.from(nextAlternateImages).map(function(container) {
              return container.querySelector('img');
            }).filter(function(img) {
              return img.getAttribute('data-src-2');
            });
  
            if (nextImagesToLoad.length > 0) {
              var nextLoadedCount = 0;
              nextImagesToLoad.forEach(function(img) {
                var onNextImageLoad = function() {
                  nextLoadedCount++;
                  if (nextLoadedCount === nextImagesToLoad.length) {
                    console.log('next images loaded');
                    nextCarousel.classList.add('is-image-loaded');
                  }
                };
  
                img.addEventListener('load', onNextImageLoad);
                img.addEventListener('error', onNextImageLoad);
                
                img.setAttribute('src', img.getAttribute('data-src-2'));
  
                if (img.complete) {
                  img.removeEventListener('load', onNextImageLoad);
                  onNextImageLoad();
                }
              });
            }
          }
        }
      }
    }
  
    // Called when scroll stops
    function onScrollStopped() {
      console.log('scroll stopped');
      var all = document.querySelectorAll('.Swipe__Mobile__CollectionCarousel');
      // Filter to only those in view
      var visible = Array.from(all).filter(function(el) {
        return isInViewport(el);
      });
      if (!visible.length) return;

      // Group containers by their vertical position (row)
      var containersByRow = {};
      visible.forEach(function(cont) {
        var rect = cont.getBoundingClientRect();
        var rowKey = Math.round(rect.top / 10) * 10; // Group by 10px tolerance
        if (!containersByRow[rowKey]) {
          containersByRow[rowKey] = [];
        }
        containersByRow[rowKey].push(cont);
      });

      // Process each row of containers
      Object.keys(containersByRow).forEach(function(rowKey) {
        var rowContainers = containersByRow[rowKey];
        
        rowContainers.forEach(function(container) {
          // Trigger custom event with the container as context
          var event = new CustomEvent('scrollStoppedOn', { bubbles: true });
          container.dispatchEvent(event);

          // Lazy-load its alternate images
          var alternateImages = container.querySelectorAll('.js-ProductItem__Image--alternate');
          // console.log('Processing container:', container, 'with', alternateImages.length, 'alternate images');
          
          var imagesToLoad = Array.from(alternateImages).map(function(container) {
            return container.querySelector('img');
          }).filter(function(img) {
            return img.getAttribute('data-src-2');
          });

          if (imagesToLoad.length > 0) {
            var loadedCount = 0;
            imagesToLoad.forEach(function(img) {
              var onImageLoad = function() {
                loadedCount++;
                if (loadedCount === imagesToLoad.length) {
                  // console.log('images loaded for container:', container);
                  container.classList.add('is-image-loaded');
                  
                  // Load next and previous carousel's images
                  loadNextCarouselImages(container);
                  loadPreviousCarouselImages(container);
                }
              };

              img.addEventListener('load', onImageLoad);
              // In case of error, we still count it to not block the process
              img.addEventListener('error', onImageLoad);
              
              img.setAttribute('src', img.getAttribute('data-src-2'));

              // Handle cached images
              if (img.complete) {
                // Manually trigger the load handler if image is already loaded
                // but remove the event listener first to avoid double-counting
                img.removeEventListener('load', onImageLoad);
                onImageLoad();
              }
            });
          }
        });
      });
    }
  
    // Bind scroll with debounce
    window.addEventListener('scroll', function() {
      console.log('scrolled');
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(onScrollStopped, scrollStopDelay);
    });
  
    // Initial check on load
    onScrollStopped();
  })();
  // END CAROUSEL IMAGES ONLY AFTER STOPPED SCROLLING